import { EventType } from "models/enumerations/events/event-type";
import { InstructorLedTrainingType } from "models/enumerations/products/instructor-led-training-type";
import { PublishStatus } from "models/enumerations/publish-status/publish-status";
import { createContext, useContext } from "react";

export interface EventSearchCriteria {
    searchText: string;
    selectedOrganization?: string;
    selectedProvider?: string;
    productId?: number;
    instructorLedTrainingType?: InstructorLedTrainingType;
    eventSalesType?: EventType;
    status?: PublishStatus;
    startDate: Date | null;
    endDate: Date | null;
    currentPage: number;
}

export interface EventSearchContextParams {
    initialCriteria: EventSearchCriteria;
    setCriteria: React.Dispatch<React.SetStateAction<EventSearchCriteria>>;
}

const defaultEventSearchCriteria: EventSearchCriteria = {
    searchText: "",
    selectedOrganization: undefined,
    selectedProvider: undefined,
    productId: undefined,
    instructorLedTrainingType: undefined,
    eventSalesType: undefined,
    status: undefined,
    startDate: null,
    endDate: null,
    currentPage: 1,
};

const EventSearchContext = createContext<EventSearchContextParams>({
    initialCriteria: defaultEventSearchCriteria,
    setCriteria: () => {},
});

const useEventSearch = () => {
    return useContext(EventSearchContext);
};

export { EventSearchContext, useEventSearch, defaultEventSearchCriteria };
